import React from 'react'
import { Link } from 'react-router-dom'

export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-[#e6e8eb] text-slate-700 py-16">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="grid grid-cols-1 gap-12 sm:grid-cols-2 min-[991px]:grid-cols-3">
          {/* Column 1: Brand Info */}
          <div className="flex flex-col gap-4">
            <Link to="/" className="flex items-center" title="Gå til forsiden · Vikar4">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=180,format=auto/assets/7b6c8b8c-dd85-4faa-a1de-b9b48f1b2725/vikar4-logo-transparent.png"
                alt="Vikar4 Vikarservice Logo"
                className="h-12 w-auto object-contain self-start"
              />
            </Link>
            <p className="text-sm text-slate-600 leading-relaxed mt-2">
              Vikar4 er et professionelt og personligt vikarbureau i Nordjylland, som tilbyder vikarservice af både kortvarig og længerevarende karakter.
            </p>
            <Link 
              to="/hvad-tilbyder-vi" 
              className="text-sm font-bold text-[#015D9A] hover:underline self-start mt-1"
            >
              Læs mere om os
            </Link>
          </div>

          {/* Column 2: Quick Links */}
          <div className="flex flex-col gap-4">
            <h3 className="text-lg font-bold text-[#0f3d5c]">Vil du se mere?</h3>
            <div className="grid grid-cols-2 gap-2">
              <div className="flex flex-col space-y-2">
                <Link to="/" className="text-sm font-semibold text-[#015D9A] hover:underline">Forside</Link>
                <Link to="/bliv-vikar" className="text-sm font-semibold text-[#015D9A] hover:underline">Bliv vikar</Link>
                <Link to="/udtalelser-fra-vikarer" className="text-sm font-semibold text-[#015D9A] hover:underline">Udtalelser</Link>
                <Link to="/hvad-tilbyder-vi" className="text-sm font-semibold text-[#015D9A] hover:underline">Hvad tilbyder vi?</Link>
              </div>
              <div className="flex flex-col space-y-2">
                <Link to="/referencer" className="text-sm font-semibold text-[#015D9A] hover:underline">Referencer</Link>
                <Link to="/medarbejdere" className="text-sm font-semibold text-[#015D9A] hover:underline">Medarbejdere</Link>
                <Link to="/mission-vision-og-vaerdier" className="text-sm font-semibold text-[#015D9A] hover:underline">Mission & Værdier</Link>
                <Link to="/kontakt" className="text-sm font-semibold text-[#015D9A] hover:underline">Kontakt</Link>
              </div>
            </div>
          </div>

          {/* Column 3: Contact Information */}
          <div className="flex flex-col gap-4">
            <h3 className="text-lg font-bold text-[#0f3d5c]">Kontakt os</h3>
            <div className="flex flex-col space-y-2 text-sm text-slate-600">
              <span className="font-bold text-[#0f3d5c]">Vikar4</span>
              <span>Skovhusevej 22, 9574 Bælum</span>
              <div className="pt-2 flex flex-col space-y-1">
                <a href="tel:27606027" className="text-[#015D9A] hover:underline font-bold flex items-center gap-2">
                  <i className="fa-solid fa-phone text-xs" />
                  (+45) 27 60 60 27
                </a>
                <a href="mailto:job@vikar4.dk" className="text-[#015D9A] hover:underline font-bold flex items-center gap-2">
                  <i className="fa-solid fa-envelope text-xs" />
                  job@vikar4.dk
                </a>
              </div>
              <span className="text-xs text-slate-500 pt-1">CVR: 40487360</span>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 border-t border-slate-300 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-500">
          <p>&copy; {currentYear} Vikar4. Alle rettigheder forbeholdes.</p>
          <div className="flex gap-6">
            <Link to="/privatlivspolitik" className="font-semibold hover:underline">
              Privatlivspolitik
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
